import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ICreateOrderRequest, IPayPalConfig } from 'ngx-paypal';

@Component({
  selector: 'app-paypal',
  templateUrl: './paypal.component.html',
  styleUrls: ['./paypal.component.scss'],
})
export class PaypalComponent implements OnInit {
  @Input() total: any = 10;
  @Input() set key(value){
    if(value){
      this.initConfig(value);
    }
  };
  @Output() sendData = new EventEmitter();

  public payPalConfig?: IPayPalConfig;

  constructor(
  ) { }

  ngOnInit() {
    //AGREGAR EL KEY
    // this._key = 'Ab8DVTreuEbdh2aYXfsDNBb-UqtOarIiWIEjTvjXE-NBZSO2ekNHahPkFrhIZomsvvtNdQVYt61Fjss7';
  }

  private initConfig(key): void {
    this.payPalConfig = {
      currency: 'USD',
      clientId: key,
      createOrderOnClient: (data) => < ICreateOrderRequest > {
        intent: 'CAPTURE',
        purchase_units: [{
          amount: {
            currency_code: 'USD',
            value: this.total,
            breakdown: {
              item_total: {
                currency_code: 'USD',
                value: this.total
              }
            }
          },
        }]
      },
      advanced: {
        commit: 'true'
      },
      style: {
        color: 'gold',
        shape: 'rect',
        label: 'paypal',
        layout: 'vertical',
      },
      onApprove: (data, actions) => {
        actions.order.capture().then(data => {
          console.log(data);
          const transactionId = data.purchase_units[0].payments.captures[0].id
          console.log('transactionId :>> ', transactionId);
          this.sendData.emit(transactionId)
        })
      },
      onClientAuthorization: (data) => {
        // console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
          // this.showSuccess = true;
      },
      onError: err => {
        console.log('OnError', err);
          // this.showError = true;
      },
    };
  }


}
